import { addMinutes } from 'date-fns';
import { useCallback } from 'react';
import { useGetStartDateTime } from '../../../components';
import type { EditEventRequest } from '../../../queries';
import type { EditEventFormValues } from '../EditEventForm';

export const useCreateFormRequestData = () => {
  const getStartDateTime = useGetStartDateTime();

  return useCallback(
    (formValues: EditEventFormValues, eventId: string): EditEventRequest => {
      const startTime = getStartDateTime({ startDate: formValues.startDate, startTime: formValues.startTime });
      const endTime = addMinutes(startTime, formValues.duration);

      return {
        data: {
          channel: {
            featuredInChannels: formValues.featuredInChannels,
            // @ts-expect-error - TODO: This will be automatically fixed once node api is updated
            organization: formValues.organization?.value ?? null,
            showInChannel: formValues.showInChannels,
            tags: formValues.tags ?? [],
          },
          endTime: endTime.toISOString(),
          html: formValues.htmlDescription,
          name: formValues.name,
          startTime: startTime.toISOString(),
          text: formValues.textDescription,
          type: formValues.type,
        },
        eventId,
      };
    },
    [getStartDateTime],
  );
};
